import { processFilters} from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';

export type Props = ApiMethodBase & { importedFilters, findingID}

export const  processFinding  = ({ importedFilters, findingID , eventEmitter,}: Props) => {
    if (importedFilters.length > 0) processFilters(importedFilters,findingID);
    eventEmitter.emit(Event.applyFilter);
    eventEmitter.emit(Event.updateGaugeMetrics);    
};


